<template>
  <div class="container">
    <breadcrumb></breadcrumb>
    <div class="option-wrap">
      <Row>
        <i-col span="20">
          <Form ref="search" :model="search" inline>
            <FormItem prop="time">
              <div class="search-item">
                <DatePicker type="daterange" v-model="search.time" placeholder="开始时间-结束时间" style="width: 100%"
                @on-change="timeChange" @on-clear="timeClear"></DatePicker>
              </div>
            </FormItem>
            <FormItem prop="pkg">
              <div class="search-item">
                <Select v-model="search.pkg" placeholder="选择应用">
                  <Option v-for="item in appList" :key="item.id" :value="item.package_name">{{item.name}}</Option>
                </Select>
              </div>
            </FormItem>
            <FormItem>
              <Button type="primary" @click="searchSubmit()">查询</Button>
              <Button @click="searchReset('search')">清空</Button>
            </FormItem>
          </Form>
        </i-col>
        <i-col span="4">
          <div class="text-right">
            <Button type="primary" @click="exportData"><Icon type="md-download" size="15" /> 导出报表</Button>
          </div>
        </i-col>
      </Row>
    </div>
    <Row v-if="chartData.rows.length">
      <i-col span="12">
        <RadioGroup v-model="velineTab" type="button" @on-change="velineXchange">
          <Radio label="hourly">小时</Radio>
          <Radio label="daily" v-if="day > 1">日</Radio>
          <Radio label="weekly" v-if="day > 7">周</Radio>
          <Radio label="monthly" v-if="day > 30">月</Radio>
        </RadioGroup>
      </i-col>
      <i-col span="12">
        <div class="text-right">
          <Select v-model="contrast.type" style="width: 120px; text-align: left">
            <Option value="date">时间对比</Option>
          </Select>
          <DatePicker type="date" placeholder="对比时间段" style="width: 200px"
                      v-model="contrast.date" @on-change="contrastChange"></DatePicker>
          <Button @click="clearContrast()">清除</Button>
        </div>
      </i-col>
    </Row>
    <ve-line v-if="chartData.rows.length" :data="chartData" :settings="chartSettings"></ve-line>
    <Table ref="table" :loading="tableLoading" class="spacingTwice" border :columns="columns" :data="dataList" @on-sort-change="sortChange"></Table>
    <Page show-total :total="total" :current="current" :page-size="pageSize" @on-change="pageChange" @on-page-size-change="pageSizeChange" show-sizer />
  </div>
</template>

<script>
import breadcrumb from '@/components/global/breadcrumb'
import utils from '../utils'
import https from '../https'
export default {
  name: 'adReport',
  data () {
    let day = new Date()
    day.setTime(day.getTime())
    let time = utils.formatDay(day, '-')
    return {
      tableLoading: true,
      showContrast: false,
      appList: [],
      slot_type: [
        { name: '开屏', val: 1 },
        { name: '插屏', val: 2 },
        { name: '信息流', val: 3 },
        { name: 'banner', val: 4 },
        { name: '贴片视频', val: 5 },
        { name: '激励', val: 6 },
        { name: '投屏后浮屏', val: 7 }
      ],
      day: 0,
      velineTab: 'hourly',
      chartData: {
        columns: ['日期', '用户数', '打开次数'],
        rows: []
      },
      chartSettings: {
        metrics: ['用户数', '打开次数'],
        dimension: ['日期']
      },
      contrast: {
        type: 'date',
        date: '',
        version: ''
      },
      search: {
        time: [time, time],
        start_time: time,
        end_time: time,
        pkg: '',
        slot_type: ''
      },
      dataSource: [], // table数据源
      columns: [ // table表格
        {
          title: '日期',
          key: 'date',
          minWidth: 120,
          // sortable: 'custom',
          // sortType: 'desc',
          align: 'center',
          fixed: 'left'
        },
        {
          title: '应用名称',
          key: 'app_name',
          minWidth: 200
        },
        {
          title: '用户数',
          key: 'user_num',
          minWidth: 100,
          align: 'center'
        },
        {
          title: '打开次数',
          key: 'open_num',
          minWidth: 100,
          align: 'center'
        }
      ],
      dataList: [], // tab当前页数据
      total: 0, // tab总条数
      pageSize: 10, // 每页多少条
      current: 1 // 当前页
    }
  },
  components: {
    breadcrumb
  },
  created () {
    if (!https.token) {
      this.$router.push('/')
      return
    }
    this.role_id = window.localStorage.getItem('role_id')
    // this.getQualification().then(this.getApplist).then(() => {
    //   this.loadData()
    //   this.loadLine()
    // })
  },
  methods: {
    // getQualification () {
    //   return new Promise(resolve => {
    //     if (parseInt(this.role_id) === 3) {
    //       https.request({
    //         method: 'get',
    //         url: '/v1/qualification/get'
    //       }).then(res => {
    //         let message = ''
    //         if (res.data.aduit_stats === 1) {
    //           message = '您已提交审核信息，请等待审核结果'
    //         } else if (res.data.aduit_stats === 3) {
    //           message = '您提交的信息未通过审核'
    //         } else if (res.data.aduit_stats === 2) {
    //           resolve()
    //           return
    //         } else {
    //           message = '您未提交审核信息</br>建议您先提交审核信息'
    //         }
    //         this.$Modal.confirm({
    //           title: '提示',
    //           content: message,
    //           onOk: () => {
    //             this.$router.push('certification')
    //           },
    //           onCancel: () => {
    //             this.$router.push('certification')
    //           }
    //         })
    //       }).catch(error => {
    //         this.$Message.error(error)
    //       })
    //     } else {
    //       resolve()
    //     }
    //   })
    // },
    // 加载应用列表
    getApplist () {
      return new Promise(resolve => {
        let params = {
          page_size: 1000,
          page: 1
        }
        https.request({
          method: 'get',
          url: '/v1/tvp/list',
          params: params
        }).then(res => {
          if (res.data.list.length) {
            this.appList = res.data.list
            resolve()
          } else {
            this.$Modal.confirm({
              title: '提示',
              content: '您未创建应用</br>建议您先创建应用',
              onOk: () => {
                this.$router.push({name: 'esApp'})
              },
              onCancel: () => {
                this.$router.push({name: 'esApp'})
              }
            })
          }
        }).catch(error => {
          this.$Message.error(error)
        })
      })
    },
    // 加载tabs列表
    loadData () {
      this.tableLoading = true
      let params = {
        start_time: this.search.start_time,
        end_time: this.search.end_time
      }
      if (this.search.pkg) params.pkg = this.search.pkg
      https.request({
        method: 'get',
        url: '/v1/total/applist',
        params: params
      }).then(res => {
        this.tableLoading = false
        if (res.data) {
          this.dataSource = res.data
          this.setData()
        }
      }).catch(error => {
        this.$Message.error(error)
        this.tableLoading = false
      })
    },
    loadLine () {
      return new Promise(resolve => {
        let start = new Date(this.search.start_time).getTime()
        let end = new Date(this.search.end_time).getTime()
        this.day = (end - start) / 24 / 60 / 60 / 1000 + 1
        if (this.day === 1) {
          this.velineTab = 'hourly'
        }
        let params = {
          start_time: this.search.start_time,
          end_time: this.search.end_time,
          time_type: this.velineTab
        }
        if (this.search.pkg) params.pkg = this.search.pkg
        https.request({
          method: 'get',
          url: '/v1/total/appline',
          params: params
        }).then(res => {
          this.velineSource = res.data
          let rows = []
          this.velineSource.forEach(n => {
            rows.push({
              '日期': n.x_line,
              '用户数': n.user_num,
              '打开次数': n.open_num
            })
          })
          this.chartData.rows = rows
          resolve()
        }).catch(error => {
          this.$Message.error(error)
        })
      })
    },
    contrastChange () {
      this.showContrast = true
      let date = new Date(this.contrast.date)
      date.setTime(date.getTime() - 24 * 60 * 60 * 1000 * (this.day - 1))
      let start_time = utils.formatDay(date, '-')
      let params = {
        start_time: this.search.start_time,
        end_time: this.search.end_time,
        time_type: this.velineTab
      }
      if (this.search.pkg) params.pkg = this.search.pkg
      if (this.contrast.type === 'date') {
        params.start_time = start_time
        params.end_time = utils.formatDay(this.contrast.date, '-')
      }
      https.request({
        method: 'get',
        url: '/v1/total/appline',
        params: params
      }).then(res => {
        this.contrastSource = res.data
        this.contrastSource.forEach((contrast, contrasti) => {
          this.chartData.rows.forEach((n, i) => {
            if (contrasti === i) {
              n['对比用户数'] = contrast.user_num
              n['对比打开次数'] = contrast.open_num
            }
          })
          console.log(this.chartData.rows)
        })
        this.velineTabChange()
      }).catch(error => {
        this.$Message.error(error)
      })
    },
    clearContrast () {
      this.showContrast = false
      this.contrast.date = ''
      this.loadLine()
      this.velineTabChange()
    },
    velineXchange () {
      this.loadLine().then(() => {
        if (this.showContrast) this.contrastChange()
      })
    },
    // 折线图对比增加tab
    velineTabChange () {
      let metrics = ['用户数', '打开次数']
      if (this.showContrast) {
        metrics.push('对比用户数')
        metrics.push('对比打开次数')
      }
      this.chartSettings = {
        metrics,
        dimension: ['日期']
      }
    },
    // 数据静态分页
    setData () {
      this.dataList = []
      this.total = this.dataSource.length
      for (let i = (this.current - 1) * this.pageSize; i < this.current * this.pageSize; i++) {
        if (i === this.total) return false
        this.dataList.push(this.dataSource[i])
      }
    },
    // 表格排序
    sortChange (data) {
      if (data.order !== 'normal') {
        this.sort = [data.key, data.order].join(' ')
        this.loadData()
      }
    },
    timeChange (data) {
      this.search.start_time = data[0]
      this.search.end_time = data[1]
    },
    timeClear () {
      this.search.start_time = ''
      this.search.end_time = ''
    },
    // 提交搜索结果
    searchSubmit () {
      if (!this.search.start_time) {
        this.$Message.error('请选择开始结束时间')
        return
      }
      this.showContrast = false
      this.contrast.date = ''
      this.current = 1
      this.velineTabChange()
      this.loadData()
      this.loadLine()
    },
    // 清空搜索结果
    searchReset (name) {
      let day = new Date()
      day.setTime(day.getTime())
      let time = utils.formatDay(day, '-')
      this.$refs[name].resetFields()
      this.search.start_time = time
      this.search.end_time = time
      this.chartData.rows = []
      this.current = 1
      this.showContrast = false
      this.velineTabChange()
      this.loadData()
      this.loadLine()
    },
    // 页数切换
    pageChange (page) {
      this.current = page
      this.setData()
    },
    // 每页条数控制
    pageSizeChange (size) {
      this.pageSize = size
      this.current = 1
      this.setData()
    },
    exportData () {
      console.log(this.dataSource.length)
      this.$refs['table'].exportCsv({
        filename: this.$route.meta.title,
        columns: this.columns,
        data: this.dataSource
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/report.vue